/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { flatten } from 'lodash';

const __vue_script__ = {
    name: 'LinkedDocuments',

    props: {
        document: {
            type: Object,
            required: true
        },

        eventId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            links: []
        };
    },

    async created() {
        this.loadLinks();
    },

    methods: {
        async loadLinks() {
            if (!this.document.fp_type) {
                return;
            }

            const fpType = this.document.fp_type;
            const metadata = await this.$services.metadata.getMetadataForTypeAsArray(this.eventId, fpType);
            const requests = metadata
                .filter(field => {
                    const value = this.document[field.field];
                    return field.kind === 'external' && value && value.length;
                })
                .map(({ field }) => this.loadFwdLinks(field));

            const links = await Promise.all(requests);
            this.links = flatten(links);
        },

        loadFwdLinks(field) {
            try {
                const doc = this.document;
                return this.$services.appScripts.callAppScript(this.eventId, 'document-service/forwardlinks', {
                    doc: {
                        _id: doc._id,
                        fp_ext_id: doc.fp_ext_id,
                        fp_type: doc.fp_type,
                        [field]: doc[field]
                    },
                    field
                });
            } catch (error) {
                console.error('[LinkedDocuments] Could not load forward links', error.message);
            }
        },

        selectItem(item) {
            this.$emit('select', item._id);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.links.length)?_c('div',{staticClass:"linked-documents"},[_c('h4',[_vm._v(_vm._s(_vm.$t('dev_tools.document_editor.linked_docs'))+" ("+_vm._s(_vm.links.length)+")")]),_vm._l((_vm.links),function(item,index){return _c('div',{key:(index + "-" + (item._id)),staticClass:"linked-doc",on:{"click":function($event){return _vm.selectItem(item)}}},[_c('div',{staticClass:"type"},[_c('i',{class:_vm.$utils.assets.getIconForType(item.fp_type)})]),_c('div',{staticClass:"details"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(item._representation)+"\n •"),_c('span',{staticClass:"t"},[_vm._v(" "+_vm._s(item.fp_type))])]),_c('div',{staticClass:"ext id"},[_vm._v(_vm._s(item.fp_ext_id || item._id))])])])})],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LinkedDocuments.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__